
// Main slide
var TwaSettingsSwiper = {
    init: function() {
       this.TwaSettingsCarousel();
       this.HalfTwaSettingsCarousel();
    },
    TwaSettingsCarousel: function() {
       document.querySelectorAll(".main__swiper").forEach((e => {
        this.TwaCarousel(e);
       }))
     },
    HalfTwaSettingsCarousel: function() {
       document.querySelectorAll(".half__swiper").forEach((e => {
        this.HalfTwaCarousel(e);
       }))
     },
     TwaCarousel: function(e) {
        var t = "true" === e?.dataset.autoplay,
            n = "true" === e.dataset.loop,
            w = e?.dataset.rows ? e?.dataset.row : 1,
            o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
            i = e?.dataset.desktop ? e?.dataset.desktop : 4,
            s = e?.dataset.tablet ? e?.dataset.tablet : 2,
            r = e?.dataset.mobile ? e?.dataset.mobile : 1,
            a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
            c = e?.dataset.speed ? e?.dataset.speed : 400,
            l = e?.dataset.effect ? e?.dataset.effect : "slide",
            d = e?.dataset.sectionId,
            u = e?.dataset.row ? e?.dataset.row : 1,
            ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
            um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
            p = window.innerWidth,
            m = e?.dataset.spacing ? e?.dataset.spacing : 0;
            cs = "true" === e.dataset.centerslide,
            // console.log(`${ut} table row` );
            // console.log(`${um} mobile row` );
            al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
            ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
            m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#main__swiper-" + d, {
            slidesPerView: r,
            slidesPerColumn: w,
            spaceBetween: m,
            centeredSlides: cs,
            autoplay: t,
            delay: a,
            loop: n,
            effect: l,
            speed: c,
            speed: 600,
            watchSlidesProgress: !0,
            watchSlidesVisibility: !0,
            freeMode: {
                enabled: true,
                momentum: true,
                momentumBounce: true,
                momentumRatio: 1,
                sticky: false
                },
            grid: {
            rows: um,
            fill: "row"
            },
            // navigation: {
            //   nextEl: e.querySelector(`.${ar}`),
            //   prevEl: e.querySelector(`.${al}`)
            // },
            navigation: {
            nextEl: `.${ar}`,
            prevEl: `.${al}`,
            },
            pagination: {
            clickable: !0,
            el: e.querySelector(".swiper-pagination")
            },
            breakpoints: {
                360: {
                    slidesPerView: 2.1,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                393: {
                    slidesPerView: 2.3,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                430: {
                    slidesPerView: 2.5,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                480: {
                    slidesPerView: 3,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                600: {
                    slidesPerView: 4,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                750: {
                    slidesPerView: s,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                835: {
                    slidesPerView: 3,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1000: {
                    slidesPerView: 3.5,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1200: {
                    slidesPerView: 4,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1280: {
                    slidesPerView: i,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                },
                1440: {
                    slidesPerView: 5.5,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                },
                1512: {
                    slidesPerView: 5.75,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                }
            }
        })
    },
    HalfTwaCarousel: function(e) {
        var t = "true" === e?.dataset.autoplay,
            n = "true" === e.dataset.loop,
            w = e?.dataset.rows ? e?.dataset.row : 1,
            o = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
            i = e?.dataset.desktop ? e?.dataset.desktop : 4,
            s = e?.dataset.tablet ? e?.dataset.tablet : 2,
            r = e?.dataset.mobile ? e?.dataset.mobile : 1,
            a = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
            c = e?.dataset.speed ? e?.dataset.speed : 400,
            l = e?.dataset.effect ? e?.dataset.effect : "slide",
            d = e?.dataset.sectionId,
            u = e?.dataset.row ? e?.dataset.row : 1,
            ut = e?.dataset.rowtablet ? e?.dataset.rowtablet : 1,
            um = e?.dataset.rowmobile ? e?.dataset.rowmobile : 1,
            p = window.innerWidth,
            m = e?.dataset.spacing ? e?.dataset.spacing : 0;
            cs = "true" === e.dataset.centerslide,
            // console.log(`${ut} table row` );
            // console.log(`${um} mobile row` );
            al = e?.dataset.arrowleft ? e?.dataset.arrowleft : "swiper-button-prev",
            ar = e?.dataset.arrowright ? e?.dataset.arrowright : "swiper-button-next",
            m = Number(m), a = Number(a), c = Number(c), p <= 767 ? m >= 15 && (m = 15) : p <= 1199 && m >= 30 && (m = 30), new Swiper("#main__swiper-" + d, {
            slidesPerView: r,
            slidesPerColumn: w,
            spaceBetween: m,
            centeredSlides: cs,
            autoplay: t,
            delay: a,
            loop: n,
            effect: l,
            speed: c,
            speed: 600,
            watchSlidesProgress: !0,
            watchSlidesVisibility: !0,
            freeMode: {
                enabled: false,
                momentum: true,
                momentumBounce: true,
                momentumRatio: 1,
                sticky: false
                },
            grid: {
            rows: um,
            fill: "row"
            },
            // navigation: {
            //   nextEl: e.querySelector(`.${ar}`),
            //   prevEl: e.querySelector(`.${al}`)
            // },
            navigation: {
            nextEl: `.${ar}`,
            prevEl: `.${al}`,
            },
            pagination: {
            clickable: !0,
            el: e.querySelector(".swiper-pagination")
            },
            breakpoints: {
                360: {
                    slidesPerView: 2.1,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                393: {
                    slidesPerView: 2.3,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                430: {
                    slidesPerView: 2.5,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                480: {
                    slidesPerView: 3,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                600: {
                    slidesPerView: 4,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                750: {
                    slidesPerView: s,
                    centeredSlides: cs,
                    spaceBetween: 8,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                835: {
                    slidesPerView: 1,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1000: {
                    slidesPerView: i,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1200: {
                    slidesPerView: i,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1280: {
                    slidesPerView: i,
                    centeredSlides: cs,
                    spaceBetween: 16,
                    grid: {
                        rows: ut,
                        fill: "row"
                    }
                },
                1350: {
                    slidesPerView: i,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                },
                1440: {
                    slidesPerView: i,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                },
                1512: {
                    slidesPerView: i,
                    spaceBetween: 16,
                    grid: {
                        rows: u,
                        fill: "row"
                    }
                }
            }
        })
    }
};

TwaSettingsSwiper.init();
document.addEventListener("shopify:section:load", function(event) {
    TwaSettingsSwiper.init();
});
